export default "__VITE_ASSET__NJPexVY1__"